import React from 'react'

const DeliveryPlanning = () => {
  return (
    <div>DeliveryPlanning</div>
  )
}

export default DeliveryPlanning